// @mui
import { Typography, Card, Stack } from '@mui/material';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import Avatar from '../../../components/Avatar';

export default function PositionCard({ position, onClick, selected }) {
  const mdUp = useResponsive('up', 'md');

  const positionDescription = {
    "developer": [
      "프론트엔드 • 백엔드 • 풀스택 • 앱",
      "DevOps • 쇼핑몰 • 게임 •  테크리드 등",
    ],
    "ai-data": [
      "데이터 엔지니어 • 데이터 사이언티스트",
      "Computer Vision • NLP • ChatGPT 등",
    ],
    "designer": [
      "UX/UI(웹/앱 서비스) • BX(브랜드) • 그래픽",
      "일러스트레이터 • 콘텐츠 디자이너 등",
    ],
    "marketer": [
      "퍼포먼스 • 콘텐츠 • CRM • 그로스 •  SEO",
      "B2B 세일즈 • 콘텐츠 에디터 • PR 등",
    ],
    "engineer": [
      "C++/C# • ROS • 하드웨어 • 로봇",
      "임베디드 • 반도체 • 생산 공정 • CAD 등",
    ],
    "product-manager": [
      "서비스 기획자 • 프로덕트 매니저",
      "사업/전략 개발 • 컨설턴트 • 운영전략 등",
    ],
    "operator": [
      "CS/CX • 운영 • 채널톡 세팅",
      "운영 자동화 • 백오피스 등",
    ],
    "finance": [
      "CFO • 회계사 • 컨설팅펌 출신 • VC",
      "파이낸셜 모델링 • 시장 조사 • IR Deck 등",
    ],
  };

  return (
    <Card
      onClick={onClick}
      variant="outlined"
      sx={{
        padding: { xs: 2, laptop: 3 },
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        boxShadow: 'none',
        '&:hover': {
          cursor: 'pointer',
          boxShadow: (theme) => theme.customShadows.z24,
        },
        ...(selected && selected == position?.key && {
          border: '1px solid black',
        }),
        ...(selected && selected !== position?.key && {
          opacity: 0.5,
        }),
      }}
    >
      <Stack>
        <Stack spacing={1.5} direction={{ xs: "row", md: "column" }} alignItems={{ xs: "center", md: "inherit" }}>
          <Avatar sx={{ width: 40, height: 40 }} src={`https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/position/position_${position.key}.png`} />
          <Stack spacing={{ xs: 0, md: 1 }}>
            <Typography variant={mdUp ? "h5" : "subtitle1"} noWrap>
              {position.value}
            </Typography>
            <Stack>
            {positionDescription[position.key].map((description, index) => (
              <Typography key={index} variant="caption">
                {description}
              </Typography>
            ))}
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Card>
  )
}